import { render, staticRenderFns } from "./ViTeacherAcademicManagementStudentAttendance.vue?vue&type=template&id=54057bb0"
import script from "./ViTeacherAcademicManagementStudentAttendance.vue?vue&type=script&lang=js"
export * from "./ViTeacherAcademicManagementStudentAttendance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports